import { render, staticRenderFns } from "./DidacticInitial.vue?vue&type=template&id=5b1cbb68&scoped=true&"
import script from "./DidacticInitial.vue?vue&type=script&lang=js&"
export * from "./DidacticInitial.vue?vue&type=script&lang=js&"
import style0 from "./DidacticInitial.vue?vue&type=style&index=0&id=5b1cbb68&scoped=true&lang=scss&"
import style1 from "./DidacticInitial.vue?vue&type=style&index=1&id=5b1cbb68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1cbb68",
  null
  
)

export default component.exports